const ABSOLUTE_HTTP_URL_RE = /^https?:\/\//i;
const DATA_URL_RE = /^data:/i;

const trimSlashEnd = (value) => String(value || '').replace(/\/$/, '');
const trimSlashStart = (value) => String(value || '').replace(/^\//, '');
const ensureSlashStart = (value) => {
  const text = String(value || '').trim();
  if (!text) return '';
  return text.startsWith('/') ? text : `/${text}`;
};
const escapeRegExp = (value) => String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const buildChatAssetUrl = ({ apiUrl = '', root = '', file = '' } = {}) => {
  const rawFile = String(file || '').trim();
  if (!rawFile) return '';
  if (ABSOLUTE_HTTP_URL_RE.test(rawFile) || DATA_URL_RE.test(rawFile)) return rawFile;

  const rawRoot = String(root || '').trim();
  if (!rawRoot) return '';

  const base = trimSlashEnd(rawRoot);
  const key = trimSlashStart(rawFile);
  if (!key) return '';

  if (ABSOLUTE_HTTP_URL_RE.test(base)) return `${base}/${key}`;

  const normalizedApiUrl = trimSlashEnd(apiUrl);
  const normalizedRoot = ensureSlashStart(base);
  if (!normalizedApiUrl) return `${normalizedRoot}/${key}`;
  return `${normalizedApiUrl}${normalizedRoot}/${key}`;
};

export const appendQueryParam = (url, key, value) => {
  if (!url || !key) return url;
  const valueText = value == null ? '' : String(value).trim();
  if (!valueText) return url;

  const pattern = new RegExp(`[?&]${escapeRegExp(key)}=`);
  if (pattern.test(url)) return url;

  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${encodeURIComponent(key)}=${encodeURIComponent(valueText)}`;
};

export const appendVariant = (url, variant) => appendQueryParam(url, 'variant', variant);

export const buildChatAssetUrlWithVariant = ({
  apiUrl = '',
  root = '',
  file = '',
  variant = '',
} = {}) => {
  const url = buildChatAssetUrl({ apiUrl, root, file });
  if (!url) return '';
  if (!variant) return url;
  return appendVariant(url, variant);
};
